<template>
  <div :class="scroll ? 'scroll_list four' : 'scroll'">
    <div class="selectList" v-if="isdataa">
      <span>
        <select name="" id="" @change="goCloum" v-model="CloumValue">
          <option value="" selected>栏目</option>
          <option
            :value="item.ArticleID"
            v-for="(item, index) in CloumnList"
            :key="index"
          >
            {{ item.Column }}
          </option>
        </select>
      </span>
    </div>
    <div
      :class="'tab_con' + view.ArticleID"
      v-for="(view, index) in List"
      :key="index"
      style="border-bottom: 1px solid #eee; padding-bottom: 15px"
    >
      <div class="leftfloat check_high" v-if="isindex">
        {{ index + 1 }}
      </div>
      <div class="tab_title">{{ view.Column }}</div>

      <div class="tab_con_left">
        <div class="ml_title">
          <a
            v-html="view.Title"
            @click="todigest($event, view.ArticleID, view.Title, type)"
          ></a>
          [{{ view.Page_Num }}-{{ view.Page_NumEnd }}]
          <a>
            <el-tooltip
              class="item"
              effect="dark"
              v-if="view.OATip != ''"
              :content="view.OATip != '' ? view.OATip : ''"
              placement="top"
            >
              <img
                src="../../assets/images/suo_open.png"
                class="lock"
                v-if="(!isdown && view.IsOA) || (isdown && view.IsOA)"
              />
              <img
                src="../../assets/images/suo_colse.png"
                class="lock"
                v-else
              />
            </el-tooltip>
            <!-- <a v-if="view.HtmlFileUrl" :href="view.HtmlFileUrl">
                <img src="../../assets/images/html.png" class="list_img" />Html
              </a> -->
          </a>
        </div>
        <div class="ml_author">
          <span v-html="view.AuthorsList"></span>
        </div>
        <div class="ycb_stage ml_author" v-if="isycb">
          <span class=""
            >出版阶段：<span style="color: red">{{
              view.PrePrintStage
            }}</span></span
          >
          <span class="advance_date"
            >最新更新时间：<span style="color: red">{{
              view.DateUpdate ? view.DateUpdate : view.DateCreate
            }}</span></span
          >
        </div>
        <div class="ycb_stage ml_author" v-if="isdatab || isdataba">
          <span class=""
            >发表期数：<span style="color: red">{{
              view.YearIssue_No
            }}</span></span
          >
          <span class="advance_date"
            >发表日期：<span style="color: red">{{
              view.Publish_Date
            }}</span></span
          >
        </div>
        <div class="ml_Doi" v-if="view.DOI">
          <span>DOI:{{ view.DOI }}</span>
        </div>

        <div class="ml_methods">
          <el-collapse v-model="activeName" accordion class="mobLista">
            <el-collapse-item>
              <template
                style="border: none; padding: 0"
                class="menthodsBut"
                v-slot:title
              >
                <i class="list_img zhaiyao"> </i>摘要
                <i class="rotator">
                  <img src="../../assets/images/down.png" />
                </i>
              </template>
              <div class="leftfloat Abstract_drop_title">摘要：</div>
              <div
                class="leftfloat Abstract_drop_con"
                v-html="view.Abstract_Chinese"
              ></div>
              <div class="clearfix"></div>
              <div class="leftfloat Abstract_drop_title" v-if="isEnzhaiy">
                Abstract：
              </div>
              <div
                class="leftfloat Abstract_drop_con"
                v-if="isEnzhaiy"
                v-html="view.Abstract_English"
              ></div>
              <div class="clearfix"></div>
            </el-collapse-item>
          </el-collapse>
          <el-popover placement="bottom-end" width="160" class="pclista">
            <div class="well">
              <div class="leftfloat Abstract_drop_title">摘要：</div>
              <div
                class="leftfloat Abstract_drop_con"
                v-html="view.Abstract_Chinese"
              ></div>
              <div class="clearfix"></div>
              <div class="leftfloat Abstract_drop_title" v-if="isEnzhaiy">
                Abstract：
              </div>
              <div
                class="leftfloat Abstract_drop_con"
                v-if="isEnzhaiy"
                v-html="view.Abstract_English"
              ></div>
              <div class="clearfix"></div>
            </div>
            <template v-slot:reference>
              <el-button style="border: none; padding: 0" class="menthodsBut">
                <i class="list_img zhaiyao"> </i>摘要
                <i class="rotator">
                  <img src="../../assets/images/down.png" />
                </i>
              </el-button>
            </template>
          </el-popover>
          <a
            @click="todigest($event, view.ArticleID, view.Title, type)"
            class="menthodsBut"
          >
            <i class="list_img liulan"></i>浏览({{ view.View_Times }})
          </a>
          <a
            @click="goHTML(view.HtmlFileUrl, view.ArticleID, view.IsOA)"
            class="menthodsBut"
            v-if="view.HtmlFileUrl"
            target="_blank"
          >
            <i class="list_img browse"></i>
            [HTML](<span style="color: red; margin-right: 0px !important">{{
              view.HtmlRead_Times
            }}</span
            >)
           
          </a>
          <a @click="goExport(view.ArticleID)" class="menthodsBut">
            <i class="list_img export"></i>导出
          </a>
          <a
            @click="pdf(index, view.PDFFile_Size, view.ArticleID, view.IsOA)"
            v-if="view.PDFFile_Size > 0"
            class="menthodsBut"
          >
            <i class="list_img down"></i>
            PDF下载
            <span class="">({{ view.Read_Times }})</span>
          </a>
          <a
            @click="oniscode(view.HtmlFileUrl, view.IsOA)"
            class="menthodsBut"
            v-if="view.HtmlFileUrl"
            title="扫码阅读HTML全文"
          >
            <i class="list_img Scancode"></i>扫码
          </a>
        </div>
        <div class="picimgs" v-if="view.Picture && isImg">
          <h3 class="small">
            <img :src="Url + view.Picture" alt="" />
          </h3>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <el-dialog
      v-model="centerDialogVisible"
      width="30%"
      center
      class="codedialog"
    >
      <p>扫码阅读HTML全文</p>
      <vue-qr :text="codeId" :size="150" class="Qrcode"></vue-qr>
    </el-dialog>
  </div>
</template>

<script>
// import vueQr from 'vue-qrcode-component-v3'
export default {
  data() {
    return {
      buttonText: '全部选中',
      isEnzhaiy: true,
      idx: 0,
      idxa: 1,
      isImg: false,
      CloumValue: '',
      centerDialogVisible: false,
      codeId: 0,
      isdown: false,
      isdowna: false,
      isdownb: false,
      activeName: 1,
      isdataba: false,
    }
  },
  components: {
    // vueQr,
  },
  props: [
    'List',
    'ischeckbox',
    'iscount',
    'count',
    'type',
    'scroll',
    'isindex',
    'CloumnList',
    'isycb',
    'allchecked',
    'allcheckedshow',
    'isdataa',
    'isdatab',
    'isgzh',
  ],
  watch: {
    List(val, newval) {
      this.buttonText = '全部选中'
    },
  },
  mounted() {
    if (localStorage.getItem('userInfo')) {
      this.isdownb = true
    }
    if (sessionStorage.getItem('SetItem')) {
      let SetItem = JSON.parse(sessionStorage.getItem('SetItem'))
      SetItem.map((item) => {
        if (item.SetItemID == 6055) {
          item.Item_Value == '是'
            ? (this.isEnzhaiy = true)
            : (this.isEnzhaiy = false)
        }
        if (item.SetItemID == 6019) {
          item.Item_Value == '是' ? (this.isdown = true) : (this.isdown = false)
        }
      })
    }

    if (this.$route.query.isdatab) {
      this.isdataba = true
    }

    this.cloumnList()
  },
  methods: {
    postGoin() {
      let ids = ''
      this.List.map((item) => {
        if (item.checked) {
          ids += item.ArticleID + ','
        }
      })
      if (ids.length <= 0) {
        return alert('请选中需要导出的文章')
      }
      var arr = ids.split('')
      arr.splice(arr.length - 1, 1)
      ids = arr.join('')
      this.$newOpen('/#/Export?ids=' + ids)
    },
    _getXZCS(id) {
      let params = {
        Id: id,
      }
      this.$store
        .dispatch('_getXZCS', params)
        .then((res) => {})
        .catch((err) => {})
    },
    success() {
      //全选/全不选
      console.log(this.List)
      if (this.buttonText == '取消选中') {
        this.buttonText = '全部选中'
        this.List.map((item) => {
          item.checked = false
        })
      } else if (this.buttonText == '全部选中') {
        this.buttonText = '取消选中'
        this.List.map((item) => {
          item.checked = true
        })
      }
    },
    todigest(e, id, title, type) {
      let path = ''
      if (type == 0) {
        path = '/digest?ArticleID=' + id + '&isgzh=2'
      } else {
        path = '/ScriptPrePrintDetailed?ArticleID=' + id
      }
      // this._getLLCS(id);
      // this.getArticList();
      e.preventDefault()
      let routeUrl = this.$router.resolve({
            path: path,
        query:{ArticleID:id}
      })
      window.open(routeUrl.href, '_blank')
    },
    oniscode(url, isoa) {
      if (!this.isdownb) {
        if (!isoa) {
          alert('只有登录用户才可以扫码查看HTML')
          return
        } else {
          this.centerDialogVisible = true
          this.codeId = url
        }
      } else {
        this.centerDialogVisible = true
        this.codeId = url
      }
    },
    _getLLCS(id) {
      let params = {
        Id: id,
      }
      this.$store
        .dispatch('_getLLCS', params)
        .then((res) => {})
        .catch((err) => {})
    },
    checkchange(val) {
      this.$forceUpdate()
    },
    todig(e, id, title) {
      this.getArticList()
      this.NewList = this.Lista
      e.preventDefault()
      // let routeUrl = this.$router.resolve({
      //   path: "/digest?ArticleID=" + id
      // });
      // window.open(routeUrl.href, "_blank");
    },
    goHTML(url, ids, isoa) {
      if (!this.isdownb) {
        if (!isoa) {
          alert('只有登录用户才可以查看HTML')
          return
        } else {
          this.$store
            .dispatch('_getHtmlRead', { id: ids })
            .then((res) => {})
            .catch((err) => {
              console.log(err)
            })
          this.$newOpen(url)
        }
      } else {
        this.$store
          .dispatch('_getHtmlRead', { id: ids })
          .then((res) => {})
          .catch((err) => {
            console.log(err)
          })
        this.$newOpen(url)
      }
    },
    goCloum() {
      var anchor = this.$el.querySelector('.tab_con' + this.CloumValue)
      if (document.querySelector('.scroll_list')) {
        document.querySelector('.scroll_list').scrollTop = anchor.offsetTop - 40
      } else {
        document.querySelector('html,body').scrollTop = anchor.offsetTop + 200
      }
      this.CloumValue = ''
      this.$forceUpdate()
    },
    goExport(ids) {
      this.$newOpen('/#/Export?ids=' + ids)
    },
    pdf(i, size, guid, isoa) {
      if (!this.isdownb) {
        if (!isoa) {
          alert('只有登录用户才可以下载')
          return
        } else {
          if (size <= 0) {
            alert('文件不存在')
            return
          }
        }
      } else {
        if (size <= 0) {
          alert('文件不存在')
          return
        }
      }
      this.$store.dispatch('_getPDF', { Id: guid }).then((Result) => {
        window.location.href = Result.request.responseURL
      })
    },
    onImg() {
      this.idx = 1
      this.idxa = 0
      this.isImg = true
    },
    onList(num) {
      this.idxa = 1
      this.idx = 0
      this.isImg = false
    },
    cloumnList() {
      console.log(this.List)
    },
  },
}
</script>

<style>
.banners .el-carousel {
  width: 300px;
  height: 160px;
  margin: 10px auto;
  background: none;
}
.banners .el-carousel__container {
  width: 100%;
}
.menthodsBut .list_img {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url('../../assets/images/colum_arrow.png') no-repeat;
  position: relative;
  top: 3px;
}
.menthodsBut .zhaiyao {
  background-position: 0px -57px;
}
.menthodsBut .browse {
  background-position: 0px -77px;
}
.menthodsBut .liulan {
  background-position: 0px -96px;
}
.menthodsBut .export {
  background-position: 0px 4px;
}
.menthodsBut .down {
  background-position: 0px -16px;
}
.menthodsBut .Scancode {
  background-position: 0px -36px;
}
</style>
